"use client";

import { MoonStar, SunMedium } from "lucide-react";
import { Button } from "./ui/button";
import { useSunlitTheme } from "./useSunlitTheme";

export default function ThemeToggle() {
  const { isDark, mounted, toggleTheme } = useSunlitTheme();
  const showDarkIcon = !mounted || isDark;
  const label = showDarkIcon ? "切换到亮色模式" : "切换到暗色模式";

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      aria-label={label}
      title={label}
      className="rounded-xl text-slate-900/75 transition hover:bg-black/5 hover:text-slate-950 dark:text-white/75 dark:hover:bg-white/10 dark:hover:text-white"
      onClick={() => toggleTheme()}
      suppressHydrationWarning
    >
      {showDarkIcon ? <SunMedium size={18} /> : <MoonStar size={18} />}
    </Button>
  );
}
